import { Routes, Route, Navigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { apiScopes } from "./auth/msalConfig";
import LandingPage from "./pages/LandingPage";
import NewClaimPage from "./pages/NewClaimPage";
import ClaimDetailPage from "./pages/ClaimDetailPage";
import PreferencesPage from "./pages/PreferencesPage";
import LoginPage from "./pages/LoginPage";
import AuthCallback from "./pages/AuthCallback";
import AppShell from "./components/AppShell";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const isAuthed = useIsAuthenticated();
  return isAuthed ? <>{children}</> : <Navigate to="/login" replace />;
}

export default function App() {
  const { instance } = useMsal();
  const isAuthed = useIsAuthenticated();

  if (isAuthed && instance.getAllAccounts().length > 0) {
    instance
      .acquireTokenSilent({ scopes: apiScopes, account: instance.getAllAccounts()[0] })
      .catch(() => {});
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth-callback" element={<AuthCallback />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <AppShell>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/new" element={<NewClaimPage />} />
                <Route path="/claim/:id" element={<ClaimDetailPage />} />
                <Route path="/preferences" element={<PreferencesPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppShell>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
